export const initialUserProfileState = {
    situationWhatIsYourCurrentPropertyGoal: null,
    situationAreYouAFirstTimeBuyer: null,
    situationDoYouHaveAMortgage: null,
    situationWhenDoesYourCurrentMortgageRateExpire: null,
    situationAreYouSellingAProperty: null,
    situationIsItAlreadyOnTheMarket: null,
    situationAreYouAPropertyInvestor: null,
    situationAreYouLookingToBuy: null,
    situationAreYouAHomeowner: null
};
